   <!-- Verse Label -->
    <div *ngIf="question.verses" >
        <div 
          class="captionText bold row"  
          *ngFor="let verse of question.verses; let first = first;" 
        >
          <span 
            class="verseContainer verseTitle buttonHighlight space " 
            (click)="selectVerse(verse)">{{verse.ref}}&nbsp;
          </span>
          &nbsp;
  
          <div *ngIf="first" class="regularText greyText elabel">
            <div class="r180"><h1>&#10162;</h1></div
              ><h3>&nbsp;&nbsp;{{config?.questionTemplateExplore}}</h3>
          </div>
        </div>
      </div>

      <div id="verseModal" class="modal" [ngClass]="{modalExit:!showVerse, hide: !showVerse}" (click)="closeModal($event)"> <!-- old id = "myMoal" -->
        <!-- The Verse Modal -->
              <!-- Modal content -->
              <div class="modalContent" (click)="stopPropagation($event)">
                  <div class="modal-header">
                      <span class="close" (click)="setVerseShown(false)">&times;</span>
                      <h2>{{config?.questionTemplateVersion}}</h2>
                  </div>
                    <div class="modal-body">
                    <h2 *ngIf="selectedVerse">{{selectedVerse.ref}}</h2>
                    <p  *ngIf="selectedVerse">{{selectedVerse.body}}</p>
                  </div>
                  <div class="modal-footer">
                  <h3></h3>
                  </div>
              </div>
        </div>